import { CollectionViewer, DataSource } from "@angular/cdk/collections";
import { Observable, BehaviorSubject, of } from "rxjs";
import { catchError, finalize } from "rxjs/operators";

import { Reserva } from '@app/_models/reserva';
import { ReservasService } from './reservas.service';


export class ReservasDataSource implements DataSource<Reserva> {

    private reservasSubject = new BehaviorSubject<Reserva[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    public loading$ = this.loadingSubject.asObservable();
    public total: number = 0;

    constructor(
        private reservasService: ReservasService
    ) {}

    loadReservas(facility_id: number,
                sortDirection: string,
                status: string,
                searchText: string,
                pageIndex: number,
                pageSize: number,
                
            ) {

        this.loadingSubject.next(true);
        pageIndex += 1;
        this.reservasService.findReservas(facility_id, sortDirection, status, searchText, pageIndex, pageSize)
            .pipe(
                catchError(() => of([])),
                finalize(() => this.loadingSubject.next(false))
            )
            .subscribe(reservas => {
                this.total = reservas['total'];
                this.reservasSubject.next(reservas['payload']);
            });
    }

    connect(collectionViewer: CollectionViewer): Observable<Reserva[]> {
        return this.reservasSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
        this.reservasSubject.complete();
        this.loadingSubject.complete();
    }

}